module.exports = __webpack_public_path__ + "media/images/writer-offering-badge-ac3fb80e90b669bd5e9719fe36721ccd.png";